import { IConfirmation } from '@ral/utils:core/confirmation';
import { createNoopInjectionToken } from 'ngxtension/create-injection-token';

export const [injectConfirmationData, provideConfirmationData] = createNoopInjectionToken<IConfirmation, false>(
    'Aui Confirmation data'
);
